// src/api/modulesApi.js
import axios from "axios";

export const updateRole = async (id, updatedRole) => {
  try {
    const response = await axios.put(`http://localhost:8080/webnet-hms/api/roles/${id}`, updatedRole);
    console.log(response.data);
  } catch (error) {
    window.alert("Error updating roles:", error);
    throw error;
  }
};
